import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { SharedModule } from 'app/shared/shared.module';
import { CtrlIconsModule } from '@co-3/ctrl-ui/icons';
import { Contract } from '@models/contract';
import { ProductsService } from '../../../products/products.service';
import { InsertHyphensPipe } from 'app/shared/pipes/insert-hyphens.pipe';
import { InsuranceTypePipe } from 'app/shared/pipes/insurance-type.pipe';

@Component({
    selector: 'button[contractListItem]',
    imports: [SharedModule, CtrlIconsModule, InsuranceTypePipe, InsertHyphensPipe],
    templateUrl: './contract-list-item.component.html',
    styleUrl: './contract-list-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractListItemComponent {
    public contract = input.required<Contract>();

    private productsService = inject(ProductsService);

    protected product = computed(() => this.productsService.getCanonicalByInsuranceType(this.contract().insuranceType));

    protected icon = computed(() => this.product()?.portalConfig.icon ?? 'insurance_fallback');

    protected iconSize = computed(() => this.product()?.portalConfig.iconSize ?? '52px');

    protected openDamage = computed(
        () => this.product()?.portalConfig.openDamageLabel ?? 'Schadensmeldung in Bearbeitung',
    );
}
